import React, {Component} from 'react';
import {Spin, Row, Col} from 'antd';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

import ChartCustomTooltip from './ChartCustomTooltip'

class StationDeviceDatasChart extends Component {
  render() {
    const {ainChartData, device, fetching} = this.props
    const values = ainChartData.map((data) => {
      return data.Value
    })
    const maxValue = Math.max(...values)
    const minValue = Math.min(...values)
    return <div className="chart-card">
      <div className="content">
        {
          fetching
            ? <span className="center"><Spin/></span>
            : <div>
                <Row type="flex">
                  <Col xs={{
                      span: 12
                    }} sm={{
                      span: 12
                    }} md={{
                      span: 6
                    }} lg={{
                      span: 4
                    }} xl={{
                      span: 2
                    }}>
                    <div className="number-info">
                      <div className="sub-title">giá trị cao nhất</div>
                      <div className="value">
                        <span className="max">{maxValue}<em className="suffix">{device.Unit}</em>
                        </span>
                      </div>
                    </div>
                  </Col>
                  <Col xs={{
                      span: 12
                    }} sm={{
                      span: 12
                    }} md={{
                      span: 6
                    }} lg={{
                      span: 4
                    }} xl={{
                      span: 2
                    }}>
                    <div className="number-info">
                      <div className="sub-title">giá trị thấp nhất</div>
                      <div className="value">
                        <span className="min">{minValue}<em className="suffix">{device.Unit}</em>
                        </span>
                      </div>
                    </div>
                  </Col>
                </Row>
                <div></div>
                <ResponsiveContainer width="100%" height={480}>
                  <AreaChart data={ainChartData}>
                    <XAxis dataKey="Time"/>
                    <YAxis/>
                    <Tooltip content={<ChartCustomTooltip text = {
                        device.Name
                      }
                      unit = {
                        device.Unit
                      } />}/>
                    <Area type='monotone' dataKey='Value' stroke='#02713B' fill='#d6ffce'/>
                  </AreaChart>
                </ResponsiveContainer>
              </div>
        }
      </div>
    </div>
  }
}

export default StationDeviceDatasChart



// WEBPACK FOOTER //
// ./src/components/StationDeviceDatasChart.js